import App from "./components/App";
import { AppContainer } from "react-hot-loader";
import { initializeIcons } from "@fluentui/font-icons-mdl2";
import { FluentProvider, webLightTheme } from "@fluentui/react-components";
import * as React from "react";
import * as ReactDOM from "react-dom";

/* global document, Office, module, require */

initializeIcons();

let isOfficeInitialized = false;
const title = "BlinKRS for Excel";

const render = (Component) => {
  ReactDOM.render(
    <AppContainer>
      <FluentProvider theme={webLightTheme}>
        <Component title={title} isOfficeInitialized={isOfficeInitialized} />
      </FluentProvider>
    </AppContainer>,
    document.getElementById("container")
  );
};

/* Render application after Office initializes */
Office.onReady((result) => {
  if (result.host !== Office.HostType.Excel) {
    // eslint-disable-next-line no-undef
    window.location.href = "https://blinkrs.pl";
    return;
  } else {
    isOfficeInitialized = true;
    let isOfficeOnline: boolean = result.platform === Office.PlatformType.OfficeOnline;
    // eslint-disable-next-line no-undef
    localStorage.setItem("isOfficeOnline", isOfficeOnline.toString());
    render(App);
  }
});

if ((module as any).hot) {
  (module as any).hot.accept("./components/App", () => {
    const NextApp = require("./components/App").default;
    render(NextApp);
  });
}
